import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface IFormColumn {
  children: ReactNode;
}

const Column = styled.div`
  display: inline-block;
  vertical-align: top;
  padding: 24px 0;
  width: 59.1%;
`;

const FormColumn = ({ children }: IFormColumn): JSX.Element => {
  return <Column>{children}</Column>;
};

export default FormColumn;
